import { render, staticRenderFns } from "./invalid.vue?vue&type=template&id=66268048&lang=pug&"
import script from "./invalid.ts?vue&type=script&lang=ts&"
export * from "./invalid.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports